var els = $('[data-category-autocomplete]');
if (els.length > 0) {
  require.ensure('../modules/category_autocomplete_input', function(require) {
    var CategoryAutocompleteInput = require('../modules/category_autocomplete_input');
    els.each(function() {
      return new CategoryAutocompleteInput(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/category_autocomplete_input.initializer.js